import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box } from "@mui/material"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"

import BackIcon from "../../../components/BackIcon"
import CustomActionsTableServer from "../../../components/CustomActionsTableServerSide"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import { useNavigate } from "react-router-dom"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const CrearVendedorPedidosMostrador = () => {
  const navigate = useNavigate()

  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Asistente de Ventas</b>
        </div>

        <Box className={StyledRoot}>
          <CustomActionsTableServer
            endpoint="/VendedorPedidosMostrador/getAllCitas"
            errorMsgFilterSearch="Error en cargar datos"
            queryKeyModal="VendedorPedidosMostradorCitas"
            perPage={10}
            rowActions={[
              {
                label: "Ver",
                key: "VerAction",
                icon: <RemoveRedEyeIcon sx={{ color: "#76987D" }} />,
                onClick: (row) => {
                  navigate(`cita`, {
                    state: row?.original,
                  })
                },
              },
            ]}
            columnsTable={[
              {
                accessorKey: "vennombre",
                header: "Vendedor",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nickname",
                header: "Nickname",
                size: 200,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "comentario",
                header: "Comentario",
                size: 300,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "pedfecven",
                header: "Fecha Vencimiento",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },

              {
                accessorKey: "pedfecemi",
                header: "Fecha Emisión",
                size: 150,
                Cell: ({ cell }) => {
                  const value = cell.getValue()
                  return <span>{normalFormatDate(value)}</span> // Formatear la fecha
                },
              },

              {
                accessorKey: "pednumped",
                header: "ID Cita",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CrearVendedorPedidosMostrador
